import StatsCentreLayout from './StatsCentre';

export { StatsCentreLayout }

export default {
	StatsCentreLayout
}

export * from '../../../core/layouts';